import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
  selector: "icon-partner-foncia",
  template: `
    <svg
      id="Logo_Foncia"
      viewBox="0 0 178.677 53.639"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="modele">
        <g id="Groupe_49">
          <g id="Groupe_48">
            <path
              class="fill-current"
              id="Tracé_251"
              d="M62.037 69.151v6.206h13.026V62.04z"
              transform="translate(-62.037 -62.038)"
            />
            <path
              class="fill-current"
              id="Tracé_252"
              d="M151.7 69.147v6.2h-13.028v-13.32z"
              transform="translate(-122.581 -62.027)"
            />
            <path
              class="fill-current"
              id="Rectangle_899"
              d="M0 0H13.026V13.025H0z"
              transform="translate(0 16.384)"
            />
            <path
              class="fill-current"
              id="Tracé_253"
              d="M138.672 145.75v6.183H151.7V138.6z"
              transform="translate(-122.581 -122.523)"
            />
            <path
              class="fill-current"
              id="Tracé_254"
              d="M228.334 145.775v6.183h-13.023v-13.326z"
              transform="translate(-183.129 -122.548)"
            />
            <path
              class="fill-current"
              id="Rectangle_900"
              d="M0 0H13.026V13.024H0z"
              transform="translate(0 32.474)"
            />
            <path
              class="fill-current"
              id="Rectangle_901"
              d="M0 0H13.023V13.024H0z"
              transform="translate(16.087 32.474)"
            />
            <path
              class="fill-current"
              id="Rectangle_902"
              d="M0 0H13.024V13.02H0z"
              transform="translate(32.181 32.487)"
            />
          </g>
        </g>
      </g>
      <g id="Groupe_50" transform="translate(49.508 23.244)">
        <path
          class="cls-6"
          class="fill-current"
          id="Tracé_255"
          d="M297.826 197.052h4.944v-8.386h8.963v-4.58h-8.963v-4.171h9.692v-4.58h-14.636z"
          transform="translate(-297.826 -174.79)"
        />
        <path
          class="cls-6"
          class="fill-current"
          id="Tracé_256"
          d="M406.514 175.814a10.8 10.8 0 0 0-3.711-2.285 14.173 14.173 0 0 0-9.368 0 10.8 10.8 0 0 0-3.711 2.285 10.419 10.419 0 0 0-2.44 3.605 13.179 13.179 0 0 0 0 9.436 10.415 10.415 0 0 0 2.44 3.605 10.78 10.78 0 0 0 3.711 2.285 14.174 14.174 0 0 0 9.368 0 10.787 10.787 0 0 0 3.711-2.285 10.413 10.413 0 0 0 2.439-3.605 13.175 13.175 0 0 0 0-9.436 10.417 10.417 0 0 0-2.439-3.605zm-8.4 15.148a6.966 6.966 0 0 1-2.71-.509 6.088 6.088 0 0 1-2.077-1.42 6.292 6.292 0 0 1-1.33-2.153 8.3 8.3 0 0 1 0-5.474 6.268 6.268 0 0 1 1.33-2.168 6.1 6.1 0 0 1 2.077-1.419 7.478 7.478 0 0 1 5.42 0 6.11 6.11 0 0 1 2.077 1.419 6.279 6.279 0 0 1 1.33 2.168 8.293 8.293 0 0 1 0 5.474 6.3 6.3 0 0 1-1.33 2.153 6.1 6.1 0 0 1-2.077 1.42 6.966 6.966 0 0 1-2.706.509z"
          transform="translate(-367.81 -172.732)"
        />
        <path
          class="cls-6"
          class="fill-current"
          id="Tracé_257"
          d="M535.719 190.123l-9.046-14.787h-6.6v21.716h4.944V181.9l9.26 15.1.03.049h6.358v-21.712h-4.944z"
          transform="translate(-473.407 -174.79)"
        />
        <path
          class="cls-6"
          class="fill-current"
          id="Tracé_258"
          d="M657.872 188.7a5.067 5.067 0 0 1-1.817 1.668 5.266 5.266 0 0 1-2.534.6 5.5 5.5 0 0 1-2.342-.507 5.777 5.777 0 0 1-1.9-1.418 6.841 6.841 0 0 1-1.272-2.156 8.295 8.295 0 0 1 0-5.474 6.652 6.652 0 0 1 1.287-2.17 5.787 5.787 0 0 1 4.375-1.926 5.641 5.641 0 0 1 2.313.447 4.583 4.583 0 0 1 1.68 1.278l.064.079 3.8-3.106-.063-.079a7.47 7.47 0 0 0-1.6-1.509 8.8 8.8 0 0 0-1.86-.983 10.424 10.424 0 0 0-1.964-.537 11.574 11.574 0 0 0-1.916-.169 13.418 13.418 0 0 0-4.684.8 10.8 10.8 0 0 0-3.711 2.285 10.419 10.419 0 0 0-2.44 3.605 13.174 13.174 0 0 0 0 9.436 10.41 10.41 0 0 0 2.44 3.605 10.78 10.78 0 0 0 3.711 2.285 13.423 13.423 0 0 0 4.684.8 10.87 10.87 0 0 0 4.355-.92 8.367 8.367 0 0 0 3.506-2.86l.058-.081-4.116-3.071z"
          transform="translate(-570.066 -172.732)"
        />
        <path
          class="cls-6"
          class="fill-current"
          id="Rectangle_903"
          d="M0 0H4.944V21.716H0z"
          transform="translate(97.312 .547)"
        />
        <path
          class="cls-6"
          class="fill-current"
          id="Tracé_259"
          d="M817.48 175.4l-.026-.061H813.4l-9.385 21.716h5.451l1.793-4.557h8.217l1.853 4.557h5.571zm.3 12.882h-4.956l2.464-6.3z"
          transform="translate(-697.732 -174.79)"
        />
      </g>
    </svg>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconPartnerFonciaComponent {}
